import React from "react";
import "../style/bottom.css";
import trophy from "../assets/trophy-icon.png";
import Call from "../assets/Call.png";
import Whatsapp from "../assets/whatsapp.png";
import Insta from "../assets/instagram.png";
import Youtube from "../assets/utube.png";
import Linkedin from "../assets/linkedin.png";
import email from "../assets/email.png";
import flag from "../assets/indianflag.png";

const BottomContent = () => {
  return (
    <div className="Background-Black">
      <div className="container-1">
        <div className="image-icon">
          {/* <img src={flag} alt="icon" className="Building-img" /> */}
          <span>Engineer M. Karuppasamy B.E(Civil).,</span>
        </div>
        <div className="image-icon">
          <img src={flag} alt="icon" className="Building-img" />
          <span>1/1989/22, Pandian nagar,Virudhunagar - 626 001</span>
        </div>
      </div>
      <div className="container-1">
        <div className="image-icon">
          <img src={Call} alt="icon" className="Building-img" />
          <span>9486384663</span>
        </div>
        <div className="image-icon">
          <img src={Whatsapp} alt="icon" className="Building-img" />
          <span>9486384663</span>
        </div>
        <div className="image-icon">
          <img src={Insta} alt="icon" className="Building-img" />
          <span>black_construction_and_ds</span>
        </div>
      </div>

      <div className="container-1">
        <div className="image-icon">
          <img src={Youtube} alt="icon" className="Building-img" />
          <span>Black Custruction</span>
        </div>
        <div className="image-icon">
          <img src={Linkedin} alt="icon" className="Building-img" />
          <span>Black Construction and Design Studio</span>
        </div>
        <div className="image-icon">
          <img src={email} alt="icon" className="Building-img" />
          <span>blackconstructionanddesignstud@gmail.com</span>
        </div>
      </div>
    </div>
  );
};

export default BottomContent;
